import { Button, EmptyState, ModuleCard, Skeleton } from "@nabble/ui";
import { useNavigate } from "react-router-dom";
import type { AppModule } from "../../../layout/appModules";
import { moduleLanding } from "../../../layout/navigation";
import { useShellContext } from "../../../layout/shellContext";

const PLACEHOLDER_CARDS = [0, 1];

function ModuleGridLoading(): React.JSX.Element {
  return (
    <div className="nb-grid nb-grid-mod">
      {PLACEHOLDER_CARDS.map((i) => (
        <div key={i} className="nb-card nb-card-pad nb-stack">
          <Skeleton width={44} height={44} radius={12} />
          <Skeleton width="50%" height={16} />
          <Skeleton width="85%" height={12} />
        </div>
      ))}
    </div>
  );
}

function NoModules(): React.JSX.Element {
  const navigate = useNavigate();
  return (
    <div className="nb-card">
      <EmptyState
        icon="grid"
        title="You don't have any modules enabled yet"
        description="Ask an administrator to give you a role with access to the modules you need."
        action={<Button label="View my account" variant="secondary" icon="user" onClick={() => navigate("/account/profile")} />}
      />
    </div>
  );
}

function ModuleGrid({ modules }: { modules: AppModule[] }): React.JSX.Element {
  const navigate = useNavigate();
  return (
    <div className="nb-grid nb-grid-mod">
      {modules.map((m, index) => (
        <ModuleCard
          key={m.id}
          name={m.label}
          description={m.description}
          icon={m.icon}
          status="Active"
          stat={m.sections.length === 1 ? "1 section" : `${m.sections.length} sections`}
          index={index}
          onOpen={() => navigate(moduleLanding(m))}
        />
      ))}
    </div>
  );
}

/** The modules the user can open, while they load, or a hint when there are none. */
export function YourModules(): React.JSX.Element {
  const { appModules, modulesLoading } = useShellContext();
  if (modulesLoading) return <ModuleGridLoading />;
  if (appModules.length === 0) return <NoModules />;
  return <ModuleGrid modules={appModules} />;
}
